import { jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync, LL_V_L } from '@nu-art/thunderstorm-frontend';
import './Component_SearchResults.scss';
import { Virtuoso } from 'react-virtuoso';
export class Component_SearchResults extends ComponentSync {
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state.searchResults ??= nextProps.context.getSearchResults();
        return state;
    }
    __onSearchResultsChanged = () => {
        this.setState({ searchResults: this.props.context.getSearchResults() });
    };
    componentDidMount() {
        this.props.context.searchResultChangeListeners.register(this);
    }
    componentWillUnmount() {
        this.props.context.searchResultChangeListeners.unregister(this);
    }
    //######################### Render #########################
    getSearchItemMap = () => {
        return this.props.context.getActiveSearchItems().reduce((map, searchItem) => {
            map[searchItem.module.dbDef.dbKey] = searchItem;
            return map;
        }, {});
    };
    //######################### Render #########################
    render() {
        const searchItemMap = this.getSearchItemMap();
        const results = this.state.searchResults?.filter(result => searchItemMap[result.dbKey]);
        if (!results?.length)
            return this.render_NoResults();
        return _jsx(Virtuoso, { className: 'c__search-results', data: results, style: { height: 0 }, itemContent: (_, result) => searchItemMap[result.dbKey].resultRenderer(result), totalListHeightChanged: listHeight => {
                if (listHeight > 0 && this.state.listHeight !== listHeight)
                    this.setState({ listHeight });
            } });
    }
    render_NoResults = () => {
        return _jsx(LL_V_L, { className: 'c__search-results no-results', children: "No results to show" });
    };
}
//# sourceMappingURL=Component_SearchResults.js.map